import { Browser } from '@capacitor/browser';

/**
 * Opening a gateway's own payment page (InGo ADR 0047): Stripe's card page
 * holds the card, so InGo never sees it.
 *
 * - **In the Android app:** an in-app browser tab over the app
 *   (`@capacitor/browser`, a Custom Tab), which the app closes itself the
 *   moment its poll hears the payment confirmed (Kangaru's top-up: "the
 *   poll's answer is what closes the page").
 * - **On the website:** the same window. The card page sends the client back
 *   to `/pay/return`, which reads the payment from the server.
 */

function onPhone() {
  return Boolean(typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.());
}

/** Opens the page. Answers how: `tab` (it stays open over the app) or `window` (this page leaves). */
export async function openCheckout(url, { phone = onPhone, browser = Browser, location = typeof window !== 'undefined' ? window.location : null } = {}) {
  if (phone()) {
    await browser.open({ url });

    return 'tab';
  }
  location?.assign(url);

  return 'window';
}

/** Closes the in-app tab, if one is open. Nothing on the website. */
export async function closeCheckout({ phone = onPhone, browser = Browser } = {}) {
  if (!phone()) return;
  try {
    await browser.close();
  } catch {
    // Already closed by the client, or never opened.
  }
}
